import { Paper, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import ListFilters from "./ListFilters/ListFilters";
import WorkshopList from "./WorkshopList";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import GroupsIcon from "@mui/icons-material/Groups";
import { useDispatch } from "react-redux";
import { setFilterMyWorkshops } from "../../state/workshopSlice";
import style from "./ListContainer.module.css";

const ListContainer = () => {
  const dispatch = useDispatch();
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (e, index) => {
    setCurrentTab(index);
    index === 1
      ? dispatch(setFilterMyWorkshops(true))
      : dispatch(setFilterMyWorkshops(false));
  };

  return (
    <>
      <Paper variant="outlined" className={style.list}>
        <ListFilters />
        <Tabs value={currentTab} onChange={handleTabChange} variant="fullWidth">
          <Tab
            label="All Workshops"
            icon={<GroupsIcon />}
            iconPosition="start"
          />
          <Tab
            label="My Workshops"
            icon={<HowToRegIcon />}
            iconPosition="start"
          />
        </Tabs>
        {currentTab === 0 && <WorkshopList />}
        {currentTab === 1 && <WorkshopList />}
      </Paper>
    </>
  );
};

export default ListContainer;
